<template>
  <div id="camera-error-ios" class="fade-in">
    <StepInfo btnText="Recarregar página" @btnClick="refreshPage" iconName="refresh">
      <h2>Habilite o acesso à câmera</h2>
      <p>
        Para tirar a foto do documento é necessário que a câmera esteja habilitada.
      </p>

      <Asset
        name="o-camera-error-ios.svg"
        alt="Barra de pesquisa do ios"
        title="Barra de pesquisa do ios"
      />

      <div class="tutorial-step">
        <span>1</span>
        <div>
          <p>
            Em seguida selecione a opção <b>“Ajustes do Site”</b>
          </p>
          <Icon name="gear" />
        </div>
      </div>

      <div class="tutorial-step">
        <span>2</span>
        <p>
          Em seguida toque em <b>“Configurações do site”</b>
        </p>
      </div>

      <div class="tutorial-step">
        <span>3</span>
        <p>
          Na nova tela, toque no item <b>“Câmera”</b> e selecione a opção
          <b>“Permitir”</b>.Para concluir toque em <b>“OK”</b> na parte
          superior da tela.
        </p>
      </div>

    </StepInfo>
  </div>
</template>

<script>
import Asset from '@/components/common/Asset.vue';
import Icon from '@/components/ui/AppIcon.vue';

import StepInfo from '../components/StepInfo.vue';

export default {
  name: 'camera-error-ios',
  components: { StepInfo, Asset, Icon },
  methods: {
    refreshPage() {
      this.$router.replace({
        name: 'onboarding-main',
        query: this.$route.query,
      }).then(() => {
        this.$router.go();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  #camera-error-ios {
    h2 {
      color: var(--gray-600);
      margin-top: 24px;
    }

    p {
      @extend .lead;
      line-height: 26px;
    }

    img {
      width: 100%;
      margin-top: 20px;
    }

    .tutorial-step {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 16px 0;

      span {
        min-width: 20px;
        min-height: 20px;

        margin-right: 8px;

        border-radius: 50%;
        background: var(--primary-washed);
        color: #fff;

        display: flex;
        justify-content: center;
        align-items: center;
      }

      img {
        width: 20px;
        margin: 0;
        margin-left: 6px;
      }

      div {
        p {
          display: inline;
        }

        img {
          position: absolute;
          margin-top: 2px;
        }
      }
    }
  }
</style>
